import React from 'react';
import { Box, Typography } from '@mui/material';
import PassengerForm from './PassengerForm';

const RoomsForm = ({ roomsArray, formik, search }) => {
  return (
    <>
      {roomsArray?.map((room, roomIndex) => {
        // 🔑 obtenemos pasajeros + índice REAL de Formik
        const passengersInRoom = formik.values.passengers
          .map((passenger, index) => ({
            passenger,
            formikIndex: index,
          }))
          .filter(({ passenger }) => passenger.room === room.id);

        return (
          <Box
            key={`room-${roomIndex}`}
            sx={{
              mx: 'auto',
              mb: 1,
              p: 2,
              border: '4px solid #E5E5E5',
              borderRadius: 2,
              background: '#FFF',
            }}
          >
            <Typography
              fontWeight={700}
              textAlign="left"
              color="tertiary.main"
              sx={{ mb: 2, fontSize: { xs: 18, sm: 20 } }}
            >
              {`Habitación ${roomIndex + 1}`}
            </Typography>

            {passengersInRoom.map(({ passenger, formikIndex }) => (
              <PassengerForm
                key={formikIndex}
                passenger={passenger}
                paxIndex={formikIndex}
                formik={formik}
                search={search}
              />
            ))}
          </Box>
        );
      })}
    </>
  );
};

export default RoomsForm;
